import React, { Component } from 'react'
import TextInput from 'components/Inputs/TextInput'
import SelectInput from 'components/Inputs/SelectInput'
import { cloneDeep } from 'lodash'
import { withRouter } from 'react-router'

import Button from 'components/Button/Button'

import Table from 'components/Table/Table'

import { Mutation } from 'react-apollo'

import { OPEN_MODAL } from 'graphql/modal-graphql'

import { graphql, compose } from 'react-apollo'

import Loader from 'components/Loader/Loader'

class List extends Component {
	state = {
		searchDisplayValue: '',
		searchValue: '',
		selectedBroker: null,
		renderList: (this.props.data && (this.props.data.type == 'person' || this.props.data.type == 'company')) ? false : true
	}

	searchChangeDebouncer = null

	componentDidMount() {
		setTimeout(_ => {
			window.requestAnimationFrame(_ => {
				this.setState({
					renderList: true
				})
			})
		},1000)
	}

	handleChange = value => {
		this.setState({
			searchDisplayValue: value
		})

		clearTimeout(this.searchChangeDebouncer)

		this.searchChangeDebouncer = setTimeout(_ => {
			this.setState({
				searchValue: value.toLowerCase()
			})
		}, 500)
	}

	hiddenBySearch = item => {
		const {
			data
		} = this.props

		const {
			searchValue,
			selectedBroker
		} = this.state

		let hiddenBySearchText = false
		let hiddenByBroker = false

		if (data.hiddenBySearch) {
			hiddenBySearchText = data.hiddenBySearch(item, searchValue)
		}

		if (selectedBroker && item.broker) {
			hiddenByBroker = item.broker.id !== selectedBroker
		}

		return hiddenBySearchText || hiddenByBroker
	}

	handleBrokerChange = (brokerId) => {
		this.setState({
			selectedBroker: brokerId
		})
	}

	getBrokerOptions = () => {
		const { rows } = this.props.data
		if (!rows) return []

		const brokers = rows
			.filter(item => item.broker)
			.map(item => item.broker)
			.filter((broker, index, self) => 
				index === self.findIndex(b => b.id === broker.id)
			)

		const brokerOptions = [
			{ value: null, label: 'All Brokers' },
			...brokers.map(broker => ({
				value: broker.id,
				label: `${broker.firstName} ${broker.lastName}`
			}))
		]

		return brokerOptions
	}

	render() {
		const { 
			rows, 
			modalObject, 
			getter, 
			columns, 
			changeSortingCallback, 
			sorting, 
			type,
		} = this.props.data

		const {
			renderList,
			searchDisplayValue,
			searchValue,
			selectedBroker
		} = this.state

		let searchString = ''

		switch (type) {
			case 'liability':
				searchString = 'Search liabilities...'
				break
			case 'asset':
				searchString = 'Search assets...'
				break
			case 'person':
				searchString = 'Search people...'
				break
			case 'company':
				searchString = 'Search companies...'
				break
		}

		const brokerOptions = this.getBrokerOptions()
		const showBrokerFilter = (type === 'person' || type === 'company') && brokerOptions.length > 1

		return (
			<div>
				<div
					className="search-button-container" 
					style={{display: 'flex', gap: '15px', width: '100%'}}
				>
					<TextInput 
						value={searchDisplayValue} 
						changeCallback={this.handleChange} 
						type="search" 
						placeholder={searchString} 
					/>
					{showBrokerFilter && (
						<SelectInput
							label="Filter by Broker"
							value={selectedBroker}
							values={brokerOptions}
							changeCallback={this.handleBrokerChange}
							noDefault={true}
						/>
					)}
					<Mutation mutation={OPEN_MODAL}>
						{openModal => (
							<Button label={`Add ${type}`} 
								style={{width: '300px'}}
								callback={() => {
									openModal({
										variables: {
											operation: 'add',
											dataType: type,
											isVisible: true,
											object: modalObject
										}
									})
							}} />
						)}
					</Mutation>
				</div>
				<Loader 
					isLoading={!renderList} 
					showText={true}
				/>
				{ renderList ?
					<Table 
						dataType={type} 
						changeSortingCallback={changeSortingCallback} 
						sorting={sorting} 
						searchValue={searchValue} 
						searchDisplayValue={searchDisplayValue}
						hiddenBySearch={this.hiddenBySearch} 
						columns={columns} 
						data={rows} 
						getter={getter} 
						hideValuesUntilSearch={false}
					/> 
					:
					<div className="table-placeholder" />
				}
			</div>
		)
	}
}

export default withRouter(compose(graphql(OPEN_MODAL, { name: 'openModal' }))(List))